// extracted by mini-css-extract-plugin
module.exports = {"editQuantityRoot":"editQuantityRoot--51717","editQuantityColumn":"editQuantityColumn--d19ed"};